import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import bootbox from 'bootbox'
import { toast } from 'react-toastify'

import setting from '../../../utils/Settings'
import { appendModel, deleteSite, modifyModelAttr, orgChange  } from '../../../../features/site/siteSlice'
import { addSite, updateSite, deleteSiteById, uploadLogo } from '../../../utils/Organizations'
import BrandUsers from '../UserTypes/BrandUsers'
import SidePanelToggle from '../../Layout/Common/SidePanelToggle'
import { getImageSpecs, MILITARY_DICTIONARY, toBase64 } from '../../../utils/common'
import { getAgentTokens } from '../../../utils/Sites'
import { getUsers } from '../../../utils/Users'

const INITIAL_STATE = {
    userServicePanel: false,
    searchTerm: "",
    logo: null
}
function BrandModification(props){
    const dispatch = useDispatch()
    const searchTermRef = useRef(null)

    const [state, setState] = useState(INITIAL_STATE)

    const isAdmin = useSelector(state => state.session.isAdmin)
    const model = useSelector(state => state.site.model)

    useEffect(() => {
        if(isAdmin){
            getAgentTokens().then(({ response, error }) => {
                if(response && response.salesTokens){
                    dispatch(appendModel({
                        salesTokens: response.salesTokens
                            .sort((a, b) => a.name !== null && b.name !== null && a.name.toUpperCase()>b.name.toUpperCase() ? 1 : a.name===b.name ? 0 : -1)
                    }))
                }
            })
        }
                
    }, [isAdmin])

    useEffect(() => {
        if(state.userServicePanel){
            getUsers(model.orgForm.siteId).then(({response, error}) => {
                if(response){
                    dispatch(appendModel({
                        users: response.users || []
                    }))
                } else {
                    dispatch(appendModel({
                        users: []
                    }))
                }
            })
        }
    }, [state.userServicePanel])

    const onDelete = async() => {
        bootbox.confirm({
            size: "small",
            title: `Corfirmation`,
            message: `Are you sure you want to delete ${model.orgForm.name}?`,
            buttons: {
                cancel: {
                    label: '<i class="fa fa-times"></i> No'
                },
                confirm: {
                    className: 'btn-danger',
                    label: '<i class="fa fa-check"></i> Yes'
                }
            },
            callback: async function (result) {
                if(result){

                    const {response, error } = await deleteSiteById(model?.orgForm?.siteId)
                    
                    if(response){
                        toast.success("Company has been deleted", {containerId: "defaultToastContainer"})

                        await dispatch(deleteSite({
                            siteId: model?.orgForm?.siteId, 
                            siteType: "ORG"
                        }))

                        await props.onDeleteSite(model?.orgForm?.siteId, "ORG")
                    }
                }
            }
        });

    }

    const onChange = (property="attr", bool=false) => (e) => {
        let modelCopy = {orgForm: {...model.orgForm}}

        if(property){
            modelCopy.orgForm[property] = {
                ...modelCopy.orgForm[property],
                [e.target.name]: bool ? !modelCopy.orgForm[property][e.target.name] : e.target.value
            }
        } else {
            modelCopy.orgForm[e.target.name] = bool ? !modelCopy.orgForm[e.target.name] : e.target.value
        }

        dispatch(appendModel(modelCopy))
    }

    const saveSite = async() => {
        if(model.orgForm?.siteId) {
            let logoUrl = model.orgForm?.attr?.logo ?? null

            if(state.logo !== null){
                const respLogo = await uploadLogo(state.logo)
                let logoObj = respLogo?.response ? JSON.parse(new TextDecoder().decode(respLogo?.response)) : {}

                logoUrl = logoObj?.logoUrl ?? null
            }

            await updateSite(model.orgForm?.siteId, null, {
                site: {
                    ...model.orgForm,
                    attr: {
                        ...model?.orgForm?.attr,
                        logo: logoUrl
                    }
                }
            })
            
            let all = [...model.all]

            const allIdx = all.findIndex(a => a.siteId === model.orgForm.siteId)

            if(allIdx){
                all[allIdx] = {
                    ...model.orgForm, 
                    attr: {
                        ...model?.orgForm?.attr,
                        logo: logoUrl
                    } 
                }
            }

            let organizations = [...model.organizations]

            organizations[model.orgActiveIdx] = {
                ...model.orgForm, 
                attr: {
                    ...model?.orgForm?.attr,
                    logo: logoUrl
                } 
            }
            
            dispatch(appendModel({
                logo: logoUrl,
                organizations,
                all
            }))

            toast.success("Update successful", {containerId: "defaultToastContainer"})
        } else {
            let logoUrl = null

            if(state.logo !== null){
                const respLogo = await uploadLogo(state.logo)
                
                let logoObj = respLogo?.response ? JSON.parse(new TextDecoder().decode(respLogo?.response)) : {}
                logoUrl = logoObj?.logoUrl ?? null
            }

            let sForm = {
                ...model.orgForm,
                attr: {
                    ...model.orgForm.attr,
                    token: model.reseller ? model.userSite.siteId : isAdmin ? (model?.orgForm?.attr?.token ?? undefined) : undefined,
                    logo: logoUrl
                }
            }
            
            const {response, error} = await addSite(null, {
                site: sForm
            })

            sForm.siteId = response.siteId
            if(response.sitePath){
                sForm.sitePath = response.sitePath
            } else {
                sForm.sitePath = '/ISL/'+sForm.siteId
            }
            
            
            sForm.attr.logo = logoUrl

            dispatch(appendModel({
                logo: logoUrl,
                organizations: [...model.organizations, {...sForm}],
                organizationsFilter: [...model.organizationsFilter, {...sForm}],
                all: [...model.all, {...sForm}],
                orgForm: sForm
            }))
            
            toast.success("Site has been created successfully", {containerId: "defaultToastContainer"})
        }

    }

    const selectMilitaryBranch = (key) => {
        let modelCopy = {orgForm: {...model.orgForm}}

        if(modelCopy.orgForm?.attr?.militaryBranch === key){
            const {militaryBranch, ...attr} = model.orgForm.attr

            modelCopy.orgForm = {
                ...modelCopy.orgForm,
                attr
            }
        } else {
            modelCopy.orgForm = {
                ...modelCopy.orgForm,
                attr: {
                    ...modelCopy.orgForm.attr,
                    militaryBranch: key
                }
            }
        }
        dispatch(appendModel(modelCopy))
    }

    const onLogoChange = async(e) => {        
        const file = e.target.files[0]
        
        setState(prevState => ({
            ...prevState,
            logo: file
        }))
    }

    const handleSearchTermKeyPress = (e) => {
        let code = e.keyCode || e.which;
        if(code == 13) {
            addSearchTerm()
        }
    }

    const addSearchTerm = () => {
        let modelCopy = {orgForm: {...model.orgForm}}
        if(modelCopy.orgForm.attr?.defaultSearchTerms && modelCopy.orgForm.attr?.defaultSearchTerms.length >= 10){
            toast.error("A company can only have up to 10 search terms", {containerId: "defaultToastContainer"})
            return
        }

        modelCopy.orgForm = {
            ...modelCopy.orgForm,
            attr: {
                ...modelCopy.orgForm.attr,
                defaultSearchTerms: [
                    ...(modelCopy.orgForm.attr?.defaultSearchTerms ?? []),
                    state.searchTerm
                ]
            }
        }
        dispatch(appendModel(modelCopy))

        setState(prev => ({
            ...prev,
            searchTerm: INITIAL_STATE.searchTerm
        }))

        searchTermRef.current?.focus()
    }

    const removeSearchTerm = (key) => {
        let modelCopy = {orgForm: {...model.orgForm}}
        modelCopy.orgForm = {
            ...modelCopy.orgForm,
            attr: {
                ...modelCopy.orgForm.attr,
                defaultSearchTerms: [...modelCopy.orgForm.attr.defaultSearchTerms.filter((_, k) => k !== key)]
            }
        }

        dispatch(appendModel(modelCopy))
    }

    
    const onCRMImageChange = async(e) => {
        const { height, width } = await getImageSpecs(e.target.files[0])

        if(height !== width){
            toast.error("Image width and height must be the same number of pixels", {containerId: "defaultToastContainer"})
        } else if(height > 50 || width > 50){
            toast.error("Image width and height must be the less than or equal to 50 pixels", {containerId: "defaultToastContainer"})
        } else {
            const crmImg = await toBase64(e.target.files[0])
    
            let modelCopy = {
                orgForm: {
                    ...model.orgForm,
                    attr: {
                        ...model.orgForm.attr,
                        crmImg
                    }
                }
            }
    
            dispatch(modifyModelAttr({
                key: "orgForm",
                body: modelCopy.orgForm
            }))
        }
    }

    const { orgForm } = model

    const inputDisabled = model.reseller && model.isAffiliate ? true : false

    return <>
        <div class="card card-raised h-100">
            <div class="card-body p-20">
                <div className="d-flex justify-content-between align-items-center">
                    <div class="overline text-muted mb-4">{props.title}</div>
                    <div className="d-none d-sm-none d-md-none d-lg-block d-xl-block">
                        {(!model.reseller || (model.reseller && !model.isAffiliate)) && <div className="btn-group">
                            <button className="btn btn-lg btn-primary" onClick={() => saveSite()}>
                                <i class="fas fa-save"></i> Save
                            </button>
                            {orgForm?.siteId && !model.orgFixed && <button className="btn btn-lg btn-outline-danger" id="orgDeleteBtn" onClick={() => onDelete()}>
                                <i class="fas fa-trash-alt"></i> Delete
                            </button>}
                        </div>}
                        <div className="btn-group">
                            {orgForm?.siteId && <button className="btn btn-lg btn-outline-info" onClick={e => setState(prev => ({...prev, userServicePanel: true}))}>
                                <i class="fas fa-user-alt"></i> Users
                            </button>}
                        </div>
                    </div>
                    <div className="d-block d-sm-block d-md-block d-lg-none d-xl-none">
                        <div className="btn-group">
                            <button className="btn btn-outline-primary" onClick={() => props.onGoBack()}>
                                <i class="fas fa-chevron-circle-left"></i> Back
                            </button>
                            {!model.reseller || (model.reseller && !model.isAffiliate) && <><button className="btn btn-primary" onClick={() => saveSite()}>
                                <i class="fas fa-save"></i> Save
                            </button>
                            {orgForm?.siteId && !model.orgFixed && <button className="btn btn-outline-danger" id="orgDeleteBtn" onClick={() => onDelete()}>
                                <i class="fas fa-trash-alt"></i> Delete
                            </button>}
                            </>}
                        </div>
                        <div className="btn-group">
                            {orgForm?.siteId && <button className="btn btn-outline-info" onClick={e => setState(prev => ({...prev, userServicePanel: true}))}>
                                <i class="fas fa-user-alt"></i> Users
                            </button>}
                        </div>
                    </div>
                </div>
                <h1 className="d-none d-sm-none d-md-none d-lg-block d-xl-block">{orgForm?.name}</h1>
                <h2 className="d-block d-sm-block d-md-block d-lg-none d-xl-none">{orgForm?.name}</h2>
                <form class="form-horizontal">
                    <div class="form-group row m-b-10">
                        <label class="col-form-label col-sm-3" for="fullname">{props.title} Name:</label>
                        <div class="col-sm-6">
                            <input type="text" class="form-control" name="name" value={orgForm?.name} onChange={onChange(null)} disabled={inputDisabled} />
                        </div>
                    </div>
                    <div class="form-group row m-b-10">
                        <label class="col-form-label col-sm-3">Address:</label>
                        <div class="col-sm-6">
                            <input type="text" class="form-control" name="address" value={orgForm?.attr?.address} onChange={onChange()} disabled={inputDisabled} />
                        </div>
                    </div>
                    <div class="form-group row m-b-10">
                        <label class="col-form-label col-sm-3">City:</label>
                        <div class="col-sm-6">
                            <input type="text" class="form-control" name="city" value={orgForm?.attr?.city} onChange={onChange()} disabled={inputDisabled}  />
                        </div>
                    </div>
                    <div class="form-group row m-b-10">
                        <label class="col-form-label col-sm-3">State:</label>
                        <div class="col-sm-6">
                            <select class="form-control" name="state" value={orgForm?.attr?.state} onChange={onChange()} disabled={inputDisabled}>
                                <option value="AL">Alabama</option>
                                <option value="AK">Alaska</option>
                                <option value="AZ">Arizona</option>
                                <option value="AR">Arkansas</option>
                                <option value="CA">California</option>
                                <option value="CO">Colorado</option>
                                <option value="CT">Connecticut</option>
                                <option value="DE">Delaware</option>
                                <option value="FL">Florida</option>
                                <option value="GA">Georgia</option>
                                <option value="HI">Hawaii</option>
                                <option value="ID">Idaho</option>
                                <option value="IL">Illinois</option>
                                <option value="IN">Indiana</option>
                                <option value="IA">Iowa</option>
                                <option value="KS">Kansas</option>
                                <option value="KY">Kentucky</option>
                                <option value="LA">Louisiana</option>
                                <option value="ME">Maine</option>
                                <option value="MD">Maryland</option>
                                <option value="MA">Massachusetts</option>
                                <option value="MI">Michigan</option>
                                <option value="MN">Minnesota</option>
                                <option value="MS">Mississippi</option>
                                <option value="MO">Missouri</option>
                                <option value="MT">Montana</option>
                                <option value="NE">Nebraska</option>
                                <option value="NV">Nevada</option>
                                <option value="NH">New Hampshire</option>
                                <option value="NJ">New Jersey</option>
                                <option value="NM">New Mexico</option>
                                <option value="NY">Ney York</option>
                                <option value="NC">North Carolina</option>
                                <option value="ND">North Dekota</option>
                                <option value="OH">Ohio</option>
                                <option value="OK">Oklahoma</option>
                                <option value="OR">Oregon</option>
                                <option value="PA">Pennsylvania</option>
                                <option value="RI">Rhode Island</option>
                                <option value="SC">South Carolina</option>
                                <option value="SD">South Dekota</option>
                                <option value="TN">Tennessee</option>
                                <option value="TX">Texas</option>
                                <option value="UT">Utah</option>
                                <option value="VT">Vermont</option>
                                <option value="VA">Virginia</option>
                                <option value="WA">Washington</option>
                                <option value="WV">West Virginia</option>
                                <option value="WI">Wisconsin</option>
                                <option value="WY">Wyoming</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group row m-b-10">
                        <label class="col-form-label col-sm-3">Zip:</label>
                        <div class="col-sm-6">
                            <input type="text" class="form-control" name="zip" value={orgForm?.attr?.zip} onChange={onChange()} disabled={inputDisabled} />
                        </div>
                    </div>
                    <div class="form-group row m-b-10">
                        <label class="col-form-label col-sm-3">CRM Site URL:</label>
                        <div class="col-sm-6">
                            <input type="text" class="form-control" name="crmUrl" value={orgForm?.attr?.crmUrl} onChange={onChange()} disabled={inputDisabled} />
                        </div>
                    </div>
                    <div class="form-group row m-b-10">
                        <label class="col-form-label col-sm-3">CRM Site Icon:</label>
                        <div className={orgForm?.attr?.crmImg ? 'col-sm-3': 'col-sm-6'}>
                            <input type="file" class="form-control" onChange={onCRMImageChange} disabled={inputDisabled} />
                        </div>
                        {orgForm?.attr?.crmImg && <div class="col-sm-3">
                            <img src={orgForm?.attr?.crmImg} />
                        </div>}
                    </div>
                    <div class="form-group row m-b-10">
                        <label class="col-form-label col-sm-3">Sales Token:</label>
                        <div class="col-sm-6">
                            {(!isAdmin || orgForm?.siteId) && <label className="col-form-label" style={{fontWeight: "normal"}}>{model.reseller ? model.userSite.siteId : orgForm?.attr?.token ? orgForm?.attr.token : "ISL"}</label>}
                            {(isAdmin && !orgForm?.siteId) && <select class="form-control mr-sm-4" name="token"
                                value={orgForm?.attr.token} onChange={onChange("attr")}>
                                    <option></option>
                                {model.salesTokens.map(t => <option value={t.siteId}>{t.name}</option>)}
                            </select>}
                        </div>
                    </div>
                    <div class="form-group row m-b-10">
                        <label class="col-form-label col-sm-3">Logo:</label>
                        <div className={orgForm?.attr?.logo ? 'col-sm-3': 'col-sm-6'}>
                            <input type="file" class="form-control" onChange={onLogoChange} disabled={inputDisabled} />
                        </div>
                        {orgForm?.attr?.logo && <div class="col-sm-3">
                            <img src={orgForm?.attr?.logo} style={{width:"100%"}} />
                        </div>}
                    </div>
                    <div class="form-group row m-b-10">
                        <label class="col-form-label col-sm-3">Military Badge:</label>
                        <div class="col-sm-9">
                            {Object.keys(MILITARY_DICTIONARY).map(key => <img className={`img-thumbnail img-fluid ${orgForm.attr.militaryBranch === key ? "border border-2 border-success" : ""}`}
                                onClick={() => selectMilitaryBranch(key)}
                                src={MILITARY_DICTIONARY[key]} />)}
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <SidePanelToggle autoCloseOnBlur overrideActiveState={state.userServicePanel} showIconOnActive onClick={() =>setState(prev => ({...prev, userServicePanel: false}))}>
            <BrandUsers title={props.title} />
        </SidePanelToggle>
    </>
}

export default BrandModification